module.exports = __webpack_public_path__ + "img/1f914.179ede8.svg";